import type {
  Comment,
  FeedQueryInput,
  MediaAsset,
  Paginated,
  Post,
  PostInput,
  PostUpdateInput,
  PostWithComments,
  Reaction,
} from '@moussenaires/shared';

import { api } from './client.js';

function toQuery(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) search.set(key, String(value));
  }
  const query = search.toString();
  return query ? `?${query}` : '';
}

export const feedApi = {
  list: (query: Partial<FeedQueryInput>) => api.get<Paginated<Post>>(`/feed${toQuery(query)}`),
  get: (id: number) => api.get<PostWithComments>(`/feed/${id}`),
  create: (input: PostInput) => api.post<Post>('/feed', input),
  update: (id: number, input: PostUpdateInput) => api.patch<Post>(`/feed/${id}`, input),
  remove: (id: number) => api.delete<void>(`/feed/${id}`),

  addComment: (postId: number, body: string) =>
    api.post<Comment>(`/feed/${postId}/comments`, { body }),
  removeComment: (commentId: number) => api.delete<void>(`/feed/comments/${commentId}`),

  toggleReaction: (postId: number, emoji: string) =>
    api.post<{ reactions: Reaction[] }>(`/feed/${postId}/reactions`, { emoji }),

  upload: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.upload<MediaAsset>('/media', formData);
  },
};
